import { Component, ViewChild, Input, Output, OnChanges, EventEmitter  } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { IpValidationUtils  } from '../../../../../../common/validations/ip-validation-utils';
let $ = require('jquery');
import { AppState } from '../../../../../app.service';
import { NgForm } from '@angular/forms';
import { Service } from './connect-network.service';
import { VcaAlertsService } from '../../../../../../common/vca-alerts/vca-alerts.service';
const _ = require('lodash');

@Component({
  selector: 'connect-network',
  styles: [require('../../direct-connect.scss')],
  template: require('./connect-network.html'),
   providers: [
    TranslateService, Service
  ]
})

export class ConnectNetworkDialog {
  @Input('createData') createData;
  @Input('isEditNetwork') isEditNetwork;
  @Output('onClose') selfClose = new EventEmitter();
  @Input() isDialogOpen: boolean = false;

  private loading: boolean = false;
  private subscribeHandler;
  private isValid: boolean;
  private ipValidationUtils: IpValidationUtils = new IpValidationUtils();
  private newIPRanges;
  private dataModel = {
     gatewayAddress: '',
     maskBits: '',
     ipRanges: []
   };
  private isIpRangeValid: false;

  constructor(public service: Service, private translate: TranslateService, private alert: VcaAlertsService) {
      translate.use(GlobalVariables.LOCALE);
  }

  resetForm() {
    this.dataModel = {
      gatewayAddress: '',
      maskBits: '',
      ipRanges: []
    };
    this.newIPRanges = [];
  }
  getUpdatedDataModel() {
    return {
      gatewayAddress: this.dataModel.gatewayAddress,
      maskBits: this.dataModel.maskBits,
      ipRanges: _.cloneDeep(this.newIPRanges)
    }
  }
  onSubmitButtonClicked(f: NgForm) {
     this.loading = true;
     this.isValid = false;
     let config = this.createData.rowData.directConnectConfiguration;
     let subnets = this.createData.rowData.subnets;
     if ( this.isEditNetwork ) {
       this.updateSubnet(subnets, this.getUpdatedDataModel());
     } else {
       if (!subnets) {
         subnets = [];
       }
       subnets.push(this.getUpdatedDataModel());
     }
     this.subscribeHandler = this.service.createNetwork(config, {'subnets': subnets})
          .subscribe(
            res => {
                this.loading = false;
                this.resetForm();
                this.closeSelf();
            },
            error => {
                this.isValid = true;
                this.loading = false;
                this.alert.danger(['Operation Failed. Please try again', error], 'connect-network-dialog');
            },
            () => {
                this.service.logOperationCompleted('Connect Network to DirectConnect');
            }
          );
     return;
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

 updateSubnet(subnets, editedSubnet) {
   for (let m = 0; m < subnets.length; m++) {
      if (subnets[m].gatewayAddress === editedSubnet.gatewayAddress) {
          subnets[m].ipRanges = _.cloneDeep(this.newIPRanges);
          break;
      }
   }
 }

 isFormValid() {
    let data = this.dataModel;
    if (!this.isIpRangeValid || !data.maskBits || !data.gatewayAddress || (this.newIPRanges && this.newIPRanges.length === 0)) {
        return false;
    }
    if (!this.ipValidationUtils.isIpValid(data.gatewayAddress)) {
        return false;
    }
    return true;
  }
  onIpRangeValidation(event, ipRangeField) {
    this.isIpRangeValid = (event.valid) ? event.valid : false;
    if (this.isIpRangeValid) {
        this.newIPRanges = ipRangeField.getCurrentValue();
    }
    this.checkFormValid();
  }

  setIpRanges(event) {
    this.dataModel.ipRanges = (event.data) ? event.data : [];
  }

  checkFormValid() {
    this.isValid = this.isFormValid() ? true : false;
  }

  ngOnChanges(changes) {
     if (this.isDialogOpen && this.isEditNetwork && this.createData) {
        this.dataModel.gatewayAddress = this.createData.subnet.gatewayAddress;
        this.dataModel.maskBits = this.createData.subnet.maskBits;
        this.dataModel.ipRanges = _.cloneDeep(this.createData.subnet.ipRanges);
        this.newIPRanges = _.cloneDeep(this.createData.subnet.ipRanges);
     } else {
        this.resetForm();
     }
  }

  ngOnDestroy() {
    if (this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: 'close'
      });
    }
  }

  getDialogTitle() {
      if (this.isEditNetwork) {
        return this.translate.instant('directConnect.connectNetworkDialog.editTitle');
      } else {
        return this.translate.instant('directConnect.connectNetworkDialog.addTitle');
      }
  }

  getButtonText() {
      if (this.isEditNetwork) {
        return this.translate.instant('directConnect.update');
      } else {
        return this.translate.instant('directConnect.add');
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/dialog/connect-network/connect-network.component.ts